import { render, staticRenderFns } from "./MFASetup.vue?vue&type=template&id=705572c2&scoped=true&"
import script from "./MFASetup.vue?vue&type=script&lang=ts&"
export * from "./MFASetup.vue?vue&type=script&lang=ts&"
import style0 from "./MFASetup.vue?vue&type=style&index=0&id=705572c2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "705572c2",
  null
  
)

export default component.exports